import { render, staticRenderFns } from "./TravelAgencyPanel.vue?vue&type=template&id=14825b5e"
import script from "./TravelAgencyPanel.vue?vue&type=script&lang=js"
export * from "./TravelAgencyPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports